








































































































import axios from 'axios'
import '../../styles/tablesmargintop.css'
import edit_password from "@/components/edit_password.vue";
import {Mixins, Component} from "vue-property-decorator";
import att_mixins from "../../mixins/att";

@Component({components: {edit_password}})
export default class user_info extends Mixins(att_mixins) {

    regExp_password = (rule: any, value: string, callback: any) => {
        let pPattern = /^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z]).*$/;
        if (!pPattern.test(value)) {
            callback(new Error('至少1个大写字母,1个小写字母,1个数字'))
        } else {
            callback()
        }
    };

    valideuserinfoPassword = (rule: any, value: string, callback: any) => {
        if (value !== this.userinfo.password) {
            callback(new Error('两次输入密码不一致'))
        } else {
            callback()
        }
    };

    columns = [
        {
            title: '用户名',
            key: 'Username',
            sortable: true
        },
        {
            title: '角色',
            key: 'Rule',
            sortable: true
        },
        {
            title: '姓名',
            key: 'RealName',
            sortable: true
        },
        {
            title: '部门',
            key: 'Department',
            sortable: true
        },
        {
            title: 'email',
            key: 'Email',
            sortable: true
        },
        {
            title: '操作',
            key: 'action',
            width: 250,
            align: 'center',
            slot: 'action'
        }
    ];
    // 新建用户
    userinfo = {
        username: '',
        password: '',
        confirmpassword: '',
        group: '',
        checkbox: '',
        department: '',
        email: '',
        realname: ''
    };
    userinfoValidate = {
        username: [{
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
        }],
        password: [
            {
                required: true,
                message: '请输入密码',
                trigger: 'blur'
            },
            {
                min: 6,
                message: '请至少输入6个字符',
                trigger: 'blur'
            },
            {
                max: 32,
                message: '最多输入32个字符',
                trigger: 'blur'
            },
            {
                validator: this.regExp_password,
                trigger: 'blur'
            }
        ],
        confirmpassword: [
            {
                required: true,
                message: '请再次输入新密码',
                trigger: 'blur'
            },
            {
                validator: this.valideuserinfoPassword,
                trigger: 'blur'
            }
        ],
        group: [
            {
                required: true,
                message: '请输入权限',
                trigger: 'blur'
            }
        ],
        department: [
            {
                required: true,
                message: '请输入部门名称',
                trigger: 'blur'
            },
            {
                min: 2,
                message: '请至少输入6个字符',
                trigger: 'blur'
            },
            {
                max: 32,
                message: '最多输入32个字符',
                trigger: 'blur'
            }
        ],
        realname: [
            {
                required: true,
                message: '请输入姓名',
                trigger: 'blur'
            },
            {
                min: 2,
                message: '请至少输入2个字符',
                trigger: 'blur'
            },
            {
                max: 32,
                message: '最多输入32个字符',
                trigger: 'blur'
            }],
        email: [
            {
                required: true,
                message: '请输入工作邮箱',
                trigger: 'blur'
            },
            {
                min: 2,
                message: '请至少输入2个字符',
                trigger: 'blur'
            },
            {
                max: 32,
                message: '最多输入32个字符',
                trigger: 'blur'
            }]
    };
    editAuthForm = {
        Username: '',
        Department: '',
        RealName: '',
        Rule: '',
        Email: '',
        modal: false
    };
    // 更改部门及权限遮罩层状态
    // 用户名
    username = '';
    connectionList = {
        multi: Boolean
    };

    editPassModal(row: { Username: string; }) {
        this.username = row.Username;
        this.edit_password = true;
    }

    editAuthModal(row: any) {
        this.editAuthForm = this.$config.sameMerge(this.editAuthForm, row, this.editAuthForm);
        this.editAuthForm.modal = true;
    }

    saveAuthInfo() {
        this.savePassLoading = true;
        axios.post(`${this.$config.url}/management_user/modify`, {
            'Username': this.editAuthForm.Username,
            'Rule': this.editAuthForm.Rule,
            'Department': this.editAuthForm.Department,
            'RealName': this.editAuthForm.RealName,
            'Email': this.editAuthForm.Email
        })
            .then(res => {
                this.$config.notice(res.data);
                this.$config.clearObj(this.formItem);
                this.refreshUser(this.current)
            })
            .catch(error => {
                this.$config.err_notice(this, error)
            });
        this.savePassLoading = false
    }

    registered() {
        let is_validate: any = this.$refs['userinfova'];
        is_validate.validate((valid: boolean) => {
            if (valid) {
                this.loading = true;
                axios.post(`${this.$config.url}/management_user/register`, {
                    'userinfo': this.userinfo
                })
                    .then(res => {
                        this.loading = false;
                        this.$config.notice(res.data);
                        this.refreshUser(this.current);
                        this.userinfo = this.$config.clearObj(this.formItem)
                    })
                    .catch(error => {
                        this.loading = false;
                        this.$config.err_notice(this, error)
                    })
            }
        })
    }

    refreshUser(vl = 1) {
        axios.get(`${this.$config.url}/management_user/fetch?page=${vl}&con=${JSON.stringify(this.query)}`)
            .then(res => {
                this.connectionList.multi = res.data.multi;
                this.table_data = res.data.data;
                this.page_number = parseInt(res.data.page)
            })
            .catch(error => {
                this.$config.err_notice(this, error)
            })
    }

    delUser(row: { Username: string; }) {
        let step = this.current;
        if (this.table_data.length === 1) {
            step = step - 1
        }
        axios.delete(`${this.$config.url}/management_user/del/${row.Username}`)
            .then(res => {
                this.$config.notice(res.data)
                this.refreshUser(step)
            })
            .catch(error => {
                this.$config.err_notice(this, error)
            })
    }

    queryData() {
        this.query.valve = true;
        this.refreshUser()
    }

    queryCancel() {
        this.$config.clearObj(this.formItem);
        this.refreshUser()
    }

    mounted() {
        this.refreshUser();
    }
}
